<template>
  <div>
    <card title="team memberships" v-loading="loading.teamMemberships">
      <Table
        :items="teamMemberships"
        :columns="columns"
        :actions="actions"
        :links="links"
        filterProp="team_name"
        :loading="loading.events"
      />
    </card>
    <Dialog :show="showEditDialog" :onClose="closeEditDialog">
      <el-form label-width="200px" label-position="left" size="small">
        <el-form-item label="Created at">
          <div class="block">
            <el-date-picker v-model="editItem.created_at" type="datetime">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="Team name">
          <el-input v-model="editItem.team_name" />
        </el-form-item>
        <el-form-item label="Access Level">
          <el-select v-model="editItem.access_level">
            <el-option value="contributor" label="Contributor" />
            <el-option value="viewer" label="Viewer" />
          </el-select>
        </el-form-item>
        <el-form-item label="Active projects count">
          <el-input-number
            v-model="editItem.active_projects_count"
            :min="0"
            :step="1"
            step-strictly
          />
        </el-form-item>
        <el-form-item label="User Email">
          <el-input v-model="editItem.user_email" />
        </el-form-item>
        <el-form-item label="ID">
          <el-input v-model="editItem.id" readonly />
        </el-form-item>
        <el-form-item label="Agency">
          <el-switch v-model="editItem.is_agency"></el-switch>
        </el-form-item>
        <el-form-item label="Archived">
          <el-switch v-model="editItem.is_archived"></el-switch>
        </el-form-item>
        <el-form-item label="Role">
          <el-select v-model="editItem.role">
            <el-option value="member" label="Member" />
            <el-option value="owner" label="Owner" />
          </el-select>
        </el-form-item>
        <el-form-item label="Team">
          <el-input v-model="editItem.team" readonly />
        </el-form-item>
        <el-form-item label="Team Plan">
          <el-select v-model="editItem.team_plan">
            <el-option
              v-for="item in team_plans"
              :key="item"
              :value="item"
              :label="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Team slug">
          <el-input v-model="editItem.team_slug" />
        </el-form-item>
        <el-form-item label="Updated at">
          <div class="block">
            <el-date-picker v-model="editItem.updated_at" type="datetime">
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- <el-form-item label="User">
          <el-input v-model="editItem.user" />
        </el-form-item> -->
        <el-form-item label="User color">
          <el-color-picker
            v-model="editItem.user_color"
            show-alpha
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="User ID">
          <el-input v-model="editItem.user_user_id" />
        </el-form-item>
        <el-form-item label="User name">
          <el-input v-model="editItem.user_name" />
        </el-form-item>
        <el-form-item label="User profile picture url">
          <el-input v-model="editItem.user_profile_picture_url" />
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="!editItem.is_deleted"
            type="danger"
            @click="removeMembership"
            >Remove</el-button
          >
          <el-button
            v-if="editItem.is_deleted"
            type="success"
            @click="restoreMembership"
            >Restore
          </el-button>
          <el-button type="primary" @click="save">Save</el-button>
          <el-button @click="closeEditDialog()">Cancel</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
    <Dialog :show="showApiKeyDialog" :onClose="closeApiKeyDialog" title="API Key">
      <div class="api-key-dialog">
        <h3>API Key</h3>
        <div class="api-key-container">
          <el-input v-model="generatedApiKey" readonly>
            <template #append>
              <el-button @click="copyApiKey">
                <i class="el-icon-document-copy"></i>
                Copy
              </el-button>
            </template>
          </el-input>
        </div>
        <div class="dialog-footer">
          <el-button @click="closeApiKeyDialog">Close</el-button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { pick } from "lodash";
import { mapGetters, mapActions } from "vuex";
import Card from "@/components/Card";
import Table from "@/components/Table";
import Dialog from "@/components/Dialog";

const userColumns = [
  { label: "Team name", prop: "team_name" },
  { label: "Slug", prop: "team_slug" },
  { label: "Plan", formatter: (item) => item.team_plan || "Free" },
  {
    label: "Is deleted?",
    formatter: (item) => (item.is_deleted ? "Deleted" : "Active"),
  },
];

const teamColumns = [
  { label: "User", prop: "email" },
  {
    label: "Is deleted?",
    formatter: (item) => (item.is_deleted ? "Deleted" : "Active"),
  },
];

export default {
  data() {
    return {
      columns: [],
      actions: [{ name: "Edit", onClick: this.openEditDialog }, { name: "API Key", onClick: this.generateAPIKey }],
      links: null,
      parent: null,
      parentId: null,
      editItem: {},
      showEditDialog: false,
      showApiKeyDialog: false,
      generatedApiKey: '',
      team_plans: ["Free", "Basic", "Pro"],
    };
  },
  components: {
    Card,
    Table,
    Dialog,
  },
  computed: mapGetters(["teamMemberships", "loading"]),
  mounted() {
    this.initByRoute(this.$route);
    const { parent, parentId } = this;
    this.getTeamMemberships({ parent, parentId });
  },
  methods: {
    ...mapActions(["updateTeamMembership", "getTeamMemberships"]),
    initByRoute(newRoute) {
      const { path } = newRoute;
      const { query: id } = newRoute.params;
      this.parentId = id;
      if (path.includes("/team/")) {
        this.links = [
          { label: "View user", to: (item) => `/customers/user/${item.email}` },
        ];
        this.parent = "teams";
        this.columns = teamColumns;
      } else if (path.includes("/user/")) {
        this.links = [
          { label: "View team", to: (item) => `/customers/team/${item.team}` },
        ];
        this.parent = "users";
        this.columns = userColumns;
      }
    },
    openEditDialog(item) {
      this.editItem = { ...item };
      this.showEditDialog = true;
    },
    async generateAPIKey(item) {
      const { data } = await this.$api.get(`/user/generate_team_token/${item.user_user_id}/team/${item.team}`);
      this.generatedApiKey = data.api_key;
      this.showApiKeyDialog = true;
    },
    closeEditDialog() {
      this.showEditDialog = false;
    },
    closeApiKeyDialog() {
      this.showApiKeyDialog = false;
      this.generatedApiKey = '';
    },
    copyApiKey() {
      navigator.clipboard.writeText(this.generatedApiKey).then(() => {
        this.$message.success('API Key copied to clipboard');
      }).catch(() => {
        this.$message.error('Failed to copy API Key');
      });
    },
    async save() {
      try {
        const { parent, parentId } = this;
        const { id } = this.editItem;
        const payload = pick(this.editItem, [
          "created_at",
          "team_name",
          "access_level",
          // "active_projects_count",
          "user_email",
          // "id",
          "is_agency",
          "is_archived",
          "role",
          // "team",
          "team_plan",
          "team_slug",
          "updated_at",
          // "user",
          "user_color",
          "user_user_id",
          "user_name",
          "user_profile_picture_url"
        ]);
        await this.updateTeamMembership({ id, payload });
        this.$message.success("Updated successfully");
        this.getTeamMemberships({ parent, parentId });
      } catch (e) {
        this.$notify.error({
          title: "Failed saving changes",
          message: e.message,
        });
      } finally {
        this.closeEditDialog();
      }
    },
    restoreMembership() {
      this.setIsDeleted(false);
    },
    removeMembership() {
      this.setIsDeleted(true);
    },
    async setIsDeleted(isDeleted) {
      try {
        const { parent, parentId } = this;
        const { id } = this.editItem;
        await this.updateTeamMembership({
          id,
          payload: { is_deleted: isDeleted },
        });
        this.$message.success(
          `Team membership ${isDeleted ? "Removed" : "Restored"} successfully`
        );
        this.getTeamMemberships({ parent, parentId });
        this.closeEditDialog();
      } catch (e) {
        this.$notify.error({
          title: "Failed saving changes",
          message: e.message,
        });
      }
    },
  },
  watch: {
    $route(newRoute) {
      this.initByRoute(newRoute);
    },
  },
};
</script>

<style scoped>
.api-key-dialog {
  padding: 20px;
}

.api-key-container {
  margin: 20px 0;
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
</style>
